import { BranchByIdType } from '@features/branch-management/constants';

export const BRANCH_CONFIG_ADDITIONAL_META_QS = '?includeAdditionalMeta=true';

export type BranchConfigResponse = {
  currency?: BranchByIdType['currency'];
  default_term_label?: string;
  is_intro_msg_shared?: boolean;
  fine_config?: NonNullable<BranchByIdType['branch_config']>['fine_config'];
  limits_config?: NonNullable<BranchByIdType['branch_config']>['limits_config'];
};

/** Map GET .../branch/.../config into fields previously read from getBranchById. */
export const mapBranchConfigToBranchDetails = (
  config?: BranchConfigResponse | null
): Pick<
  BranchByIdType,
  'currency' | 'default_term_label' | 'is_intro_msg_shared' | 'branch_config'
> => {
  if (!config) {
    return {
      is_intro_msg_shared: false
    };
  }

  const { fine_config: fineConfig, limits_config: limitsConfig } = config;

  return {
    currency: config.currency,
    default_term_label: config.default_term_label,
    is_intro_msg_shared: !!config.is_intro_msg_shared,
    branch_config:
      fineConfig || limitsConfig
        ? ({
            fine_config: fineConfig,
            limits_config: limitsConfig
          } as BranchByIdType['branch_config'])
        : undefined
  };
};
